import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Users, Search } from "lucide-react";

const STATO_CLS = { attivo: "bg-emerald-100 text-emerald-800", cessato: "bg-slate-200 text-slate-600" };
export const WorkerStatoBadge = ({ stato }) => <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold uppercase ${STATO_CLS[stato || "attivo"]}`} data-testid="worker-stato-badge">{stato === "cessato" ? "Cessato" : "Attivo"}</span>;

export default function WorkersList() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState({});
  const [q, setQ] = useState("");
  const [stato, setStato] = useState("attivo");

  useEffect(() => {
    (async () => {
      const [w, c] = await Promise.all([api.get("/workers", { params: { q } }), api.get("/companies")]);
      setItems(w.data);
      setCompanies(Object.fromEntries(c.data.map(x => [x.id, x])));
    })();
  }, [q]);

  const shown = items.filter(w => stato === "tutti" || (w.stato || "attivo") === stato);

  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Anagrafica</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2"><Users size={28} /> Lavoratori</h1>
      </header>
      <div className="flex flex-wrap gap-3 items-center">
        <div className="relative max-w-md flex-1 min-w-[240px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input placeholder="Cerca per nome, cognome, CF…" value={q} onChange={(e) => setQ(e.target.value)}
            className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-lg bg-white" />
        </div>
        <div className="inline-flex rounded-lg border border-slate-300 overflow-hidden" data-testid="worker-stato-filter">
          {[["attivo", "Attivi"], ["cessato", "Cessati"], ["tutti", "Tutti"]].map(([v, l]) => (
            <button key={v} onClick={() => setStato(v)} data-testid={`worker-filter-${v}`}
              className={`px-3 py-2 text-sm ${stato === v ? "bg-slate-900 text-white" : "bg-white text-slate-700 hover:bg-slate-50"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {shown.map(w => (
          <Link key={w.id} to={`/lavoratori/${w.id}`} className={`card-lift block bg-white border border-slate-200 rounded-lg p-4 ${w.stato === "cessato" ? "opacity-70" : ""}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="font-display font-semibold text-slate-900">{w.cognome} {w.nome}</div>
              <WorkerStatoBadge stato={w.stato} />
            </div>
            <div className="text-xs font-mono text-slate-500 mt-1">{w.codice_fiscale || "—"}</div>
            <div className="text-sm text-slate-600 mt-2">{w.mansione || "—"}</div>
            <div className="text-xs text-blue-700 mt-2">{companies[w.company_id]?.ragione_sociale}</div>
          </Link>
        ))}
        {shown.length === 0 && <div className="col-span-full text-center text-slate-500 py-10">Nessun lavoratore.</div>}
      </div>
    </div>
  );
}
